<template>
  <b-container fluid class="no-bottom">
    <backlink />
    <h1>
      <div class="indicator">
        {{ items.length }}
        <i class="far fa-long-arrow-left fa-xs"></i>
      </div>
      Retours <br />en attente
    </h1>

    <b-form-group inline>
      <b-input-group>
        <b-form-input v-model="filter" placeholder="Rechercher" type="number" />
        <b-input-group-append v-if="filter">
          <b-button :disabled="!filter" @click="filter = ''" variant="outline-secondary">
            <i class="far fa-times"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <div class="table-wrapper">
      <b-table ref="table" hover show-empty :fields="fields" :items="items" :busy="isBusy" :filter="filter"
        :filter-function="filterFunction">
        <template slot="table-busy">
          <div class="text-center my-2">
            <div v-if="isBusy" class="loader"></div>
            Les données sont en cours de chargement...
          </div>
        </template>
        <template slot="empty" slot-scope="scope">
          <div class="text-center mt-2">Cette liste est vide pour le moment</div>
        </template>

        <template slot="return_number" slot-scope="data">
          <router-link v-if="$store.getters['auth/isAuthorized']('business-return_show')"
            :to="{ name: 'BusinessReturnMobileDetail', params: { id: data.item.id } }">{{ data.value }}</router-link>
          <template v-else>{{ data.value }}</template>
        </template>
        <template slot="material_retrieving_place" slot-scope="data">
          <b-badge v-if="data.value == 'axiloc'" variant="success" class="circle float-left">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-else variant="danger" class="circle float-left">
            <i class="fa fa-times"></i>
          </b-badge>
        </template>
      </b-table>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "BusinessReturnMobileList",
  data() {
    return {
      fields: [
        {
          key: "return_number",
          label: "Numéro de demande",
        },
        {
          key: "withdraw_wished_date",
          label: "Date de retour",
          formatter: "date",
        },
        {
          key: "return_warehouse",
          label: "Entrepôt",
          formatter: (value) => (value && value.name ? value.name : "-"),
        },
        {
          key: "material_retrieving_place",
          label: "Retour à l'entrepôt ESM",
        },
      ],
      filter: null,
      isBusy: false,
    };
  },
  computed: {
    // On lie 'items' au données du store (sauf si des données sont passées du parent)
    items: function () {
      return this.$store.getters["business_return/getByStatusSlug"](
        "business-return-transport-en-cours"
      ).filter((item) => {
        if (
          this.$root.isAuthorized("business-return_im-preparator") &&
          item.group_slugs &&
          item.group_slugs.includes("instruments")
        ) {
          return true;
        }
        if (
          this.$root.isAuthorized("business-return_ot-preparator") &&
          item.group_slugs &&
          item.group_slugs.includes("outillage")
        ) {
          return true;
        }
        if (
          this.$root.isAuthorized("business-return_snl-preparator") &&
          item.group_slugs &&
          item.group_slugs.includes("service_et_logistique")
        ) {
          return true;
        }
        return false;
      });
    },
  },
  mounted() {
    // On demande au store de se mettre à jour à partir de l'API
    this.$store
      .dispatch("business_return/getByStatusSlug", ["business-return-transport-en-cours"])
      .then(() => (this.isBusy = false));

    // Si il n'y a pas déjà des items dans le store, on affiche le loader le temps que le store se mette à jour
    if (!this.items || !this.items.length) {
      this.isBusy = true;
    }
  },
  methods: {
    date(value) {
      return value ? this.$moment(value).format("DD-MM-YYYY") : null;
    },
    /**
     * Fonction de filtrage utilisée par le champ de recherche.
     * Cette fonction est appliquée sur chaque item la liste
     * @param   {object}    row     Objet de la ligne à vérifier
     * @param   {string}    filter  Mots clés saisis dans le champ de recherche
     * @returns {boolean}           True si la ligne testée correspond à la recheche, sinon false
     */
    filterFunction(row, filter) {
      const fieldToFilter = ["return_number"];
      const regex = new RegExp(filter.toLowerCase().replace(/\s/g, ".*"), "gi");

      for (let index = 0; index < fieldToFilter.length; index++) {
        const field_name = fieldToFilter[index];
        const row_value = row[field_name];

        if (row_value) {
          if (row_value.toString().toLowerCase().match(regex) !== null) {
            return true;
          }
        } else {
          return false;
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/BusinessReturnMobile/BusinessReturnMobileList.vue